export default __webpack_public_path__ + "static/media/prestige_logo_full.f5ab4098.png";